/**
 * Returns the current Indian Financial Year string.
 * Indian FY runs April 1 → March 31.
 * Examples: called in May 2026 → "2026-27", called in Jan 2026 → "2025-26"
 */
export function getCurrentFYear() {
  const today = new Date();
  const month = today.getMonth(); // 0 = Jan … 3 = Apr
  const year = today.getFullYear();
  if (month >= 3) {
    // April–December: current year is the start year
    return `${year}-${String(year + 1).slice(2)}`;
  } else {
    // January–March: previous year was the start year
    return `${year - 1}-${String(year).slice(2)}`;
  }
}

/**
 * Returns the current Indian Financial Year as Date boundaries.
 * startDate = April 1 of the FY start year, endDate = March 31 of the FY end year.
 * Example: called on 2026-09-22 → { startDate: 2026-04-01, endDate: 2027-03-31 }
 */
export function getFinancialYearBounds() {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  const startYear = month >= 3 ? year : year - 1;
  const startDate = new Date(startYear, 3, 1);
  const endDate = new Date(startYear + 1, 2, 31);
  return { startDate, endDate };
}
